import SiteHeader from '@/pages/home/components/SiteHeader';
import LiveTicker from '@/pages/home/components/LiveTicker';
import HeroSection from '@/pages/home/components/HeroSection';
import IndexSection from '@/pages/home/components/IndexSection';
import HeadlineSection from '@/pages/home/components/HeadlineSection';
import FlashSection from '@/pages/home/components/FlashSection';
import CardFlowSection from '@/pages/home/components/CardFlowSection';
import HotRankSection from '@/pages/home/components/HotRankSection';
import TopicSection from '@/pages/home/components/TopicSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <LiveTicker />
        <HeroSection />
        <IndexSection />
        <HeadlineSection />
        <FlashSection />
        <CardFlowSection />
        <HotRankSection />
        <TopicSection />
      </main>
      <SiteFooter />
    </div>
  );
}